/**
 * Evento sul bus $root con cui un componente segnala una modifica del contenuto
 * applicata da codice ma richiesta dall'utente (Refine with AI, Link Builder...).
 *
 * Serve al mixin `orderAutosave`, che senza questo segnale non distinguerebbe
 * quelle modifiche dalla normalizzazione dell'HTML fatta dall'editor al mount.
 */
export const USER_EDIT_BUS_EVENT = "order-autosave:user-edit";
